import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- master Inventory Apis ------------------------------
export const getAllStateAndCity = createAsyncThunk(
    "getAllStateAndCity",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getAllStateAndCity, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const addCustomer = createAsyncThunk(
    "addCustomer",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addCustomer, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateCustomer = createAsyncThunk(
    "updateCustomer",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateCustomer, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getCustomers = createAsyncThunk(
    "getCustomers",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getCustomers, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getCustomerById = createAsyncThunk(
    "getCustomerById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getCustomerById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const deleteCustomer = createAsyncThunk(
    "deleteCustomer",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.deleteCustomer + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);